import React, { useState, useEffect } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import UserStepWizardComponent from "./user_step_wizard";

import Button from "@mui/material/Button";

import api from "../../service/api";
import $ from "jquery";

import { DebugLog, ErrorLog } from "../../helpers/logs";

export default function UpdateUserModal(props) {
  const { showUserModal, setShowUserModal, selectedUser, setSelectedUser } =
    props;
  const [open, setOpen] = useState(true);
  const [page, setPage] = useState(1);

  const [organizations, setOrganizations] = useState([]);
  const [apiRoles, setApiRoles] = useState([]);

  const handleClose = (e, reason) => {
    if (reason !== "backdropClick") {
      window.history.pushState(
        "",
        document.title,
        window.location.pathname + window.location.search
      );
      setOpen(false);
      setShowUserModal(false);
    }
  };

  useEffect(() => {
    if (showUserModal) {
      getUser();
    }
  }, [showUserModal]);

  function getUser() {
    $("#loader").show();

    api.Users.getUser(selectedUser.id)
      .then((response) => {
        var user = response.user;

        setFirstName(user.first_name);
        setLastName(user.last_name);
        setEmail(user[`e-mail`]);
        setUserPreferences(user.user_preferences);
        setNpi(user.npi);
        setRoles(user.roles != null ? user.roles.map((x) => x.id) : []);
        setLocations(user.client_locations);
        setUserId(user.id);
        setIsActive(user.active);

        getOrganizations();
      })
      .catch((er) => {
        $(`#loader`).hide();
        ErrorLog("ER: ", er);
      });
  }

  function getOrganizations() {
    api.Organizations.getAll()
      .then((response) => {
        DebugLog("Org Response: ", response);

        setOrganizations(response);

        getRoles();
      })
      .catch((er) => {
        $(`#loader`).hide();
        ErrorLog("Er: ", er);
      });
  }

  function getRoles() {
    api.Roles.getAll()
      .then((response) => {
        DebugLog("Roles Response: ", response);

        setApiRoles(response.roles);
        $(`#loader`).hide();
      })
      .catch((er) => {
        $(`#loader`).hide();
        ErrorLog("Er: ", er);
      });
  }

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [userPreferences, setUserPreferences] = useState({
    preferred_client_id: null,
    preferred_physician_id: null,
    preferred_registry_id: null,
    enable_tab_view: null,
  });
  const [roles, setRoles] = useState([]);
  const [npi, setNpi] = useState("");
  const [locations, setLocations] = useState([]);
  const [userId, setUserId] = useState("");
  const [isActive, setIsActive] = useState(false);

  const userParams = {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    password,
    setPassword,
    userPreferences,
    setUserPreferences,
    roles,
    setRoles,
    isActive,
    setIsActive,
    npi,
    setNpi,
    email,
    setEmail,
    apiRoles,
    selectedUser,
    isEdit: true,
    editLocations: locations,
    setLocations,
    userId,
  };

  return (
    <div>
      <Dialog
        lg={{
          "& .MuiDialog-paper": {
            maxWidth: "40%",
            height: 500,
            maxHeight: 500,
          },
        }}
        maxWidth="lg"
        open={showUserModal}
        onClose={handleClose}
        fullWidth
      >
        <DialogTitle>Update User</DialogTitle>
        <DialogContent style={{ height: `50rem` }}>
          <UserStepWizardComponent
            organizations={organizations}
            handleClose={handleClose}
            {...userParams}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
